import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IListNodeNavigationResponse, IFilterQuery } from '@types'

const FILTER_NODE_NAVIGATION_QUERY = gql`
  query Query($title: String, $natureCode: String) {
    filterNodeNavigation(title: $title, natureCode: $natureCode) {
      type
      payload {
        ... on NodeNavigationListResponse {
          nodeNavigationList {
            id
            id_parent
            sub_type
            title
            type
            parent_titles
            details {
              definition {
                description
              }
            }
          }
        }
      }
    }
  }
`

export const useFilterNodeNavigationQuery = (variables: IFilterQuery) => {
  const query = useQuery<IListNodeNavigationResponse>(FILTER_NODE_NAVIGATION_QUERY, variables, {
    fetchPolicy: 'cache-first'
  })
  return query
}
